import { styled, Avatar } from '@mui/material';
import OrganisationSwitcher from '../OrganisationSwitcher';
import VehicleSwitcher from '../VehicleSwitcher';
import useCurrentUser from 'hooks/data/currentUser/useCurrentUser';
import useAuth from 'hooks/auth/useAuth';
import { AdminUserRealm } from 'further-types/admin-user';

const Logo = styled('img')({
  width: '120px',
});

const AvatarWrapper = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: 16,
});

const Wrapper = styled('div')(({ theme }) => ({
  padding: '30px 16px 20px 32px',
  borderBottom: `solid 1px ${theme.palette.sidebar?.borderColor}`,
  [theme.breakpoints.up('xl')]: {
    padding: '30px 40px 20px 40px',
  },
}));

const UserInfo = styled('div')({
  paddingTop: 20,
  transition: 'all 0.1s ease',
  height: 75,
  opacity: 1,
});

const UserName = styled('h3')(({ theme }) => ({
  color: theme.palette.sidebar?.textDarkColor,
  marginBottom: 6,
  lineHeight: '13px',
  fontSize: '16px',
  display: 'block',
  width: '100%',
}));

const UserEmail = styled('p')({
  width: '100%',
  fontSize: 14,
  fontWeight: 400,
  letterSpacing: 0.25,
});

const EnvironmentFlagWrapper = styled('div')({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  marginBottom: '30px',
});

const EnvironmentFlag = styled('div', {
  shouldForwardProp: (prop) => prop !== 'backgroundColor',
})<{ backgroundColor?: string }>(({ backgroundColor }) => ({
  backgroundColor,
  color: 'white',
  padding: '6px 12px',
  borderRadius: 4,
  fontSize: 10,
  fontWeight: 'bold',
  marginLeft: 16,
  marginBottom: 0,
}));

const SidebarHeader: React.FC = () => {
  const { profile: user } = useCurrentUser();
  const { isLoading } = useAuth();

  const userName =
    user?.data?.firstName && user?.data?.lastName
      ? `${user.data.firstName} ${user.data.lastName}`
      : null;
  const firm = user?.data?.firm;
  const realm = user?.data?.realm;

  const showEnvironmentFlag =
    process.env.REACT_APP_STAGE && process.env.REACT_APP_STAGE !== 'production';
  const environmentFlagColor =
    process.env.REACT_APP_STAGE === 'uat'
      ? '#FFB366'
      : process.env.REACT_APP_STAGE === 'local'
      ? '#9595F2'
      : '#FFFFFF';

  return (
    <Wrapper>
      <EnvironmentFlagWrapper>
        <Logo src="images/logo.png" alt="profile" />
        {showEnvironmentFlag && (
          <EnvironmentFlag backgroundColor={environmentFlagColor}>
            {process.env.REACT_APP_STAGE?.toUpperCase()}
          </EnvironmentFlag>
        )}
      </EnvironmentFlagWrapper>
      {!isLoading && (
        <>
          <AvatarWrapper>
            <Avatar src={user?.data?.profilePic} />
            <OrganisationSwitcher
              otherOrgs={user?.data?.otherOrgs}
              firm={firm}
              realm={realm}
            />
          </AvatarWrapper>
          <UserInfo>
            <UserName>{userName}</UserName>
            <UserEmail>{user?.data?.email}</UserEmail>
          </UserInfo>
        </>
      )}
      {realm === AdminUserRealm.Lp && <VehicleSwitcher />}
    </Wrapper>
  );
};

export default SidebarHeader;
